import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import { ActionCreators } from "../../actions";

class UserProfile extends Component {
  state = {
    user: {
      email: "",
      passwordHash: "",
      firstName: "",
      lastName: "",
      profileImageUri: "",
      isVerified: "",
      password: "",
      id: "",
      createdOn: "",
      modifiedOn: ""
    }
  };

  componentDidMount() {
    let that = this;
    this.props.currentUserAction().then(() => {
      if (that.props.currentUser) {
        that.setState({ user: that.props.currentUser });
      }
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let that = this;
    this.props.updateUserProfileAction(that.state.user).then(() => {
      if (that.props.currentUser) {
        that.setState({ user: that.props.currentUser });
      }
    });
  }

  handleInputChange = (event, inputIdentifier) => {
    const userProfileForm = {
      ...this.state.user
    };
    userProfileForm[inputIdentifier] = event.target.value;
    this.setState({ user: userProfileForm });
  }

  render() {
    return (
      <div className="row justify-content-center">
        <div className="col-xl-6">
          <div className="card">
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="col">
                    <div className="form-field">
                      <label>First Name</label>
                      <input
                        value={this.state.user.firstName}
                        type="text"
                        onChange={event =>
                          this.handleInputChange(event, "firstName")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-field">
                      <label>Last Name</label>
                      <input
                        value={this.state.user.lastName}
                        type="text"
                        onChange={event =>
                          this.handleInputChange(event, "lastName")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-field">
                      <label>Email</label>
                      <input
                        value={this.state.user.email}
                        type="text"
                        onChange={event =>
                          this.handleInputChange(event, "email")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-field">
                      <label>Profile Picture</label>
                      <input type="file" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <button type="submit" className="gs-btn gs-btn-blue btn-lg">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserProfile)
);



// WEBPACK FOOTER //
// ./src/pages/auth/userProfile.js